import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute } from '@angular/router';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: "row-select-list",
    templateUrl: "./row-select-list.template.html",
    styles:[`
        .row-picker {
            display: block;
            margin-bottom: 30px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class RowSelectList implements OnInit {
    @Input() list: any;
    @Input() filter: string;
    @Input() config: MediaCellConfig;
    @Input() paginate: Boolean;
    @Input() selectItemQuery:any;
    @Input() selectedIndex:number = 0;

    selectedItem:any;
    selectItems:Array<any>;    
    content$: any;

    private subscriptions: Array<any> = [];
    private dataService: BehaviorSubject<Object>;

    constructor(
        private effects: CoreEffects,
        private ref: ChangeDetectorRef
    ) {
        this.dataService = new BehaviorSubject(null);
    }

    ngOnInit() {
        this.content$ = this.dataService.asObservable();
        this.subscriptions.push(this.content$.subscribe(content => {     
            if (content && content.rows) {
                this.selectItems = this.filter ? content.rows.filter(i => (i.meta || i).obj_type === this.filter) : content.rows;
                if (this.selectItemQuery && this.selectItemQuery.property && this.selectItemQuery.value) {
                    this.selectedItem = this.selectItems.filter(i => (i.meta||i)[this.selectItemQuery.property] === this.selectItemQuery.value)[0]
                } 
                if (!this.selectedItem) {
                    this.selectedItem = this.selectItems[this.selectedIndex]
                }
            }
        }));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.list && changes.list.currentValue !== changes.list.previousValue) {
            if (this.list.rows){
                this.dataService.next(this.list)
            } else {
                this.effects.loadMetaInternalRoute(this.dataService, this.list.meta)
            }
        }
    }

    onItemSelect(row) {
        this.selectedItem = row
    }

    ngOnDestroy() {
        if (this.dataService){
            this.dataService.complete();
            //this.dataService.unsubscribe();
            this.dataService = null;
        }
        this.subscriptions.forEach(s => s.unsubscribe())
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/row-select-list/row-select-list.component.ts